import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface MiscellaneousNotesInputProps {
  onMiscellaneousNotesChange: (value: string) => void;
  miscellaneousNotesValue: string;
  isEnabled: boolean;
}

export const MiscellaneousNotesInput: React.FC<MiscellaneousNotesInputProps> = ({
  onMiscellaneousNotesChange,
  miscellaneousNotesValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="Miscellaneous Notes"
      label="Enter Miscellaneous Notes:"
      placeholder="Enter miscellaneous notes..."
      value={miscellaneousNotesValue}
      onChange={onMiscellaneousNotesChange}
      isEnabled={isEnabled}
      isTextArea={true}
    />
  );
};